module.exports = __webpack_public_path__ + "img/1970East-050_WEB-min.831a6a0b.jpg";